import { computed, type ComputedRef } from 'vue';
import { useAppStore } from '@/store';

interface TenantWithPhone {
    phone?: string | null;
}

/**
 * The phone number a customer may be offered to call: the current tenant's own,
 * or none. Never another tenant's and never Muval's. Hidden when the tenant has
 * no phone, and under `?tmpl=0` embeds, matching the header and Other options.
 */
export function tenantContactPhone(tenant: TenantWithPhone | null | undefined, hideBranding: boolean): string | null {
    if (hideBranding) {
        return null;
    }

    const phone = tenant?.phone?.trim();

    return phone ? phone : null;
}

export function useTenantPhone(): ComputedRef<string | null> {
    const app = useAppStore();

    return computed(() => tenantContactPhone(app.tenant as TenantWithPhone | null, app.hideBranding));
}
